<template>
  <div
    class="relative cursor-auto"
    v-click-outside="hide"

    @click.stop="openConfig"
    @pointerdown.stop
    @pointerup.stop
  >
    <div>
      <slot></slot>
    </div>

    <portal v-if="showingPortal && !disabled" to="magento-sidebar">
      <transition
        enter-class="-translate-x-full"
        leave-class="translate-x-0"
        enter-to-class="translate-x-0"
        leave-to-class="-translate-x-full"

        appear
      >
        <div
          class="absolute ease-in-out duration-300 left-0 top-0 w-full h-full bg-white z-40 flex flex-col border-r border-gray-200"
          :class="hidePortal && '!hidden !opacity-100 !invisible'"
          @click.stop
        >
          <div class="p-4">
            <h2 class="font-bold">{{ `${title} - ${tab && tabLabelMap && tabLabelMap[tab]}` }}</h2>
          </div>

          <component v-if="!hidePortal"
             :is="tabComponent"
             v-bind="$props"
             :configuration="tabConfigMap && tabConfigMap[tab]"
          />

          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 absolute right-0 top-0 mr-2 mt-4 text-gray-600 hover:text-gray-700 cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" @click.stop="closePortalComponent">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
      </transition>
    </portal>

    <transition
      enter-class="mt-2 opacity-0"
      leave-class="mt-0 opacity-100"
      enter-to-class="mt-0 opacity-100"
      leave-to-class="mt-2 opacity-0"
    >
      <div v-if="show && !disabled" class="duration-150 border border-gray-200 bg-white w-[58em] shadow-lg absolute left-full top-full z-10 rounded-lg" @click="clickOnConfig">
        <div>
          <BlockVariants
            v-if="loadingConfig || variants.length"

            :loading="loadingConfig"
            :variants="variants"
            :id="id"
            :title="title"
            :role="role"
            :configuration="configuration"
            :currentConfig="config"
          />

          <div class="p-4 pb-0 flex justify-between">
            <h3 class="font-bold text-xl text-gray-900">{{ title }}</h3>
            <button
              class="inline-flex items-center px-2 py-1 border border-transparent text-xs font-medium duration-150 rounded text-red-700 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              @click="removeBlock"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
              </svg>
              Remove block
            </button>
          </div>
          <div v-if="(tabs && tabs.length > 0) || loadingConfig" class="border-b border-gray-200 pl-4">
            <nav class="-mb-px flex space-x-5" aria-label="Tabs">
              <span
                class="border-transparent cursor-pointer text-gray-500 hover:text-gray-700 hover:border-gray-300 duration-150 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
                :class="tab === 'GeneralTab' && !loadingConfig && '!text-blue-600 hover:!text-blue-700 !font-semibold !border-blue-700'"

                @click="tab = 'GeneralTab'"
              >
                <span :class="loadingConfig && 'forced-ske'">General</span>
              </span>
              <span v-if="loadingConfig"
                class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 duration-150 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
                :class="tab === 'GeneralTab' && !loadingConfig && '!text-blue-600 hover:!text-blue-700 !font-semibold !border-blue-700'"

                @click="tab = 'GeneralTab'"
              >
                <span class="forced-ske">General asht asht</span>
              </span>
              <span v-if="loadingConfig"
                class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 duration-150 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
                :class="tab === 'GeneralTab' && !loadingConfig && '!text-blue-600 hover:!text-blue-700 !font-semibold !border-blue-700'"

                @click="tab = 'GeneralTab'"
              >
                <span class="forced-ske">General ash</span>
              </span>

              <template v-if="!loadingConfig">
                <span
                  v-for="configTab in tabs"
                  :key="configTab"

                  class="border-transparent cursor-pointer text-gray-500 hover:text-gray-700 hover:border-gray-300 duration-150 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
                  :class="tab === tabIdMap[configTab] && '!text-blue-600 hover:!text-blue-700 !font-semibold !border-blue-700'"
                  @click.stop="tab = tabIdMap[configTab]"
                >
                  <span class="-translate-y-[1px]">{{ typeof configTab === 'string' ? configTab : configTab.label }}</span>
                </span>
              </template>
            </nav>
          </div>
        </div>

        <component
          v-if="!shouldUsePortal"

          :is="tabComponent"
          v-bind="$props"
          :tabConfiguration="tabLabelMap && tabLabelMap[tab]"
          :configuration="tabConfigMap && tabConfigMap[tab]"
        />
      </div>
    </transition>
  </div>
</template>

<script>

import GeneralTab from './GeneralTab.vue'
import BlockVariants from "@/components/SideEditor/BlockConfiguration/BlockVariants";
import FormList from "@/components/SideEditor/BlockConfigurationTabs/FormList/FormList"

import { mapGetters } from "vuex"

import CmsRichTextEditor from "@/components/SideEditor/BlockConfigurationTabs/CmsRichTextEditor/CmsRichTextEditor"
import CategoryLinksManager from "@/components/SideEditor/BlockConfigurationTabs/CategoryLinksManager/CategoryLinksManager"
import ProductListCustomUrlGenerator from "@/components/SideEditor/BlockConfigurationTabs/ProductListCustomUrlGenerator/ProductListCustomUrlGenerator"
import PhysicalShopsCrud from "@/components/SideEditor/BlockConfigurationTabs/PhysicalShopsCrud/PhysicalShopsCrud"

export default {
  components: {
    GeneralTab,
    ProductListCustomUrlGenerator,
    FormList,
    PhysicalShopsCrud,
    BlockVariants,

    CmsRichTextEditor,
    CategoryLinksManager,
  },
  props: ['id', 'title', 'role', 'config', 'content', 'disabled'],
  created() {
    this.hidePortal = true
    this.show && this.loadConfiguration()
  },
  data() {
    return {
      loadingConfig: true,
      show: false,
      tab: "GeneralTab",
      configuration: null,
      showingPortal: null,
      hidePortal: false,
      justClickedOnConfig: false,
      variants: []
    }
  },
  methods: {
    openConfig() {
      this.$store.commit("editor/iframeClick")
      requestAnimationFrame(() => {
        this.show = true
      })
    },
    closePortalComponent() {
      this.tab = "GeneralTab"
      this.show = true
    },

    async loadConfiguration() {
      this.loadingConfig = true
      const blocks = (await this.$store.dispatch("cachedGet", {
        endpoint: this.link + "/rest/V1/editor/list-available-blocks",
        headers: { Cookie: 'environment=editor' },
        params: {
          params: {
            role: this.role,
            search: this.id.includes('_') ? this.id.split("_")[0] : this.id,
            packages: this.availablePackages.map(item => item.module_id),
          },
        },
      })).data
      this.loadingConfig = false
      this.configuration = blocks[0].configuration
      this.variants = blocks[0].variants
      console.log("tabs: ", this.tabs)
    },
    hide() {
      this.show = false
    },
    removeBlock() {
      this.$store.dispatch("editor/removeBlock", {role: this.role, id: this.id})
    },
    clickOnConfig() {
      if (this.clickTimeout) {
        clearTimeout(this.clickTimeout)
      }

      this.justClickedOnConfig = true
      this.clickTimeout = setTimeout(() => this.justClickedOnConfig = false, 50)
    },
  },
  computed: {
    ...mapGetters({
      link: 'editor/fullDomainLink',
      availablePackages: 'editor/availablePackages',
      iframeClickTrigger: 'editor/iframeClickTrigger',
    }),
    tabComponent() {
      const tab = this.tab
      if (tab === "GeneralTab") return tab

      const configTab = this.tabConfigMap[tab]
      if (typeof configTab === "string") return configTab
      if (configTab.component) return configTab.component
      return "FormList"
    },
    shouldUsePortal() {
      const tab = this.tab
      if (tab === "GeneralTab") return false

      return this.tabConfigMap[tab] && this.tabConfigMap[tab].portal
    },

    tabs() {
      const config = this.configuration
      return config && Object.values(this.configuration).map(tab => typeof tab[0] === 'string' ? tab[0] : tab[0].label)
    },
    tabIdMap() {
      const config = this.configuration
      return config && Object.keys(config).reduce((idMap, id) => ({
        ...idMap,
        [typeof config[id][0] === 'string' ? config[id][0] : config[id][0].label]: id,
      }), {})
    },
    tabConfigMap() {
      const config = this.configuration
      return config && Object.keys(config).reduce((idMap, id) => ({
        ...idMap,
        [id]: config[id][1],
      }), {})
    },
    tabLabelMap() {
      const config = this.configuration
      return config && Object.keys(config).reduce((idMap, id) => ({
        ...idMap,
        [id]: config[id][0],
      }), {})
    },
    isTeleportingConfigurationToSidebar() {
      return this.showingPortal && !this.disabled
    },
  },
  watch: {
    isTeleportingConfigurationToSidebar(teleporting) {
      this.$store.commit('editor/isTeleportingConfigurationToSidebar', teleporting)
    },
    iframeClickTrigger() {
      !this.justClickedOnConfig && this.hide()
    },
    show(val) {
      /*if (val) {
        this.showingPortal = true
        setTimeout(() => this.showingPortal = false,200)
      }*/
      val && this.loadConfiguration()
    },
    shouldUsePortal(val) {
      this.showingPortal = val
      if (val) {
        this.hide()
        this.hidePortal = false
      }
    },
  },
}

</script>

